import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ComputedBook } from "_deziiign/books/core/components/helper/types/computed/ComputedBook";
import ResizedImageEnhanced from "../../../../shared/components/ResizedImageEnhanced";

export const getBookImages = (book: any, lang: any) => {
  if (lang === 'en' && book?.titleImages_en?.length) {
    return book?.titleImages_en
  }
  if (lang === 'ru' && book?.titleImages?.length) {
    return book?.titleImages
  }
  return book?.titleImages?.length ? book?.titleImages : book?.titleImages_en;
}

const BooksImage = styled(ResizedImageEnhanced)<{ isSquare?: boolean }>`
  
  img {
    height: ${({ isSquare }) => isSquare ? 'initial' : '100%'};
  }
  overflow: hidden;
`

export const PSImage: FC<{ book: ComputedBook }> = ({ book }) => {
  const { i18n } = useTranslation();

  const images = getBookImages(book, i18n.language) || [];

  return (
    <BooksImage files={images} isSquare={false}/>
  )
};
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ComputedBook } from "_deziiign/books/core/components/helper/types/computed/ComputedBook";
import ResizedImageEnhanced from "../../../../shared/components/ResizedImageEnhanced";

export const getBookImages = (book: any, lang: any) => {
  if (lang === 'en' && book?.titleImages_en?.length) {
    return book?.titleImages_en
  }
  if (lang === 'ru' && book?.titleImages?.length) {
    return book?.titleImages
  }
  return book?.titleImages?.length ? book?.titleImages : book?.titleImages_en;
}

const BooksImage = styled(ResizedImageEnhanced)<{ isSquare?: boolean }>`
  
  img {
    height: ${({ isSquare }) => isSquare ? 'initial' : '100%'};
  }
  overflow: hidden;
`

export const PSImage: FC<{ book: ComputedBook }> = ({ book }) => {
  const { i18n } = useTranslation();

  const images = getBookImages(book, i18n.language) || [];

  return (
    <BooksImage files={images} isSquare={false}/>
  )
};
